import { useState } from "react"
import { NotificationBannerView } from "./NotificationBannerView"
import { shouldOfferNotificationBanner } from "./notificationBanner"

/**
 * Offers to turn on message notifications. The button is the user gesture
 * browsers require to prompt. Closing hides it for the session only.
 */
export function NotificationPermissionBanner() {
  const [visible, setVisible] = useState(shouldOfferNotificationBanner)

  if (!visible) return null

  const dismiss = () => setVisible(false)

  // Gone either way: granted needs no banner, and denied leaves permission no
  // longer "default", so it will not return next load.
  const enable = () => {
    void Notification.requestPermission().finally(() => setVisible(false))
  }

  return <NotificationBannerView onEnable={enable} onDismiss={dismiss} />
}
